import React from 'react';

interface BIButtonProps {
    type?: 'button' | 'submit' | 'reset';
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    onClick?: () => void;
    text: string;
    isLoading?: boolean;
}

const BIButton: React.FC<BIButtonProps> = ({ type = 'button', startIcon, endIcon, isLoading, onClick, text }) => {
    return (
        <button 
            disabled={isLoading}
            type={type} 
            onClick={onClick} 
            className={`h-[42px] w-full py-2 px-4 rounded-full flex items-center justify-center transition duration-300 ${
                isLoading ? 'bg-gray-500 cursor-not-allowed' : 'bg-primary hover:bg-yellow-600'
            } text-black`}
        >
            {isLoading && startIcon ? (
                <span className="mr-2 animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-black"></span>
            ) : (
                startIcon && <span className="mr-2">{startIcon}</span>
            )}

            {text}

            {isLoading && endIcon ? (
                <span className="ml-2 animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-black"></span>
            ) : (
                endIcon && <span className="ml-2">{endIcon}</span>
            )}

            {!startIcon && !endIcon && isLoading && (
                <span className="ml-2 animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-black"></span>
            )}
        </button>
    );
}

export default BIButton;
